document.addEventListener('DOMContentLoaded', function () {
    // Select all elements with the `data-menu-drawer` or `data-drawer-options` attribute
    const menuButtons = document.querySelectorAll('[data-drawer-options]');
    
    menuButtons.forEach(button => {
        // Get drawer ID from data-drawer-options (make sure the JSON is properly parsed)
        const drawerOptions = JSON.parse(button.getAttribute('data-drawer-options'));
        const drawerId = drawerOptions.id;
        const drawer = document.querySelector(drawerId);

        if (!drawer) return; // If no drawer is found, skip

        // Event listener for clicking the menu button
        button.addEventListener('click', function (event) {
            event.preventDefault(); // Prevent default action (e.g., navigation)

            // Toggle the aria-hidden attribute to show/hide the drawer
            const isHidden = drawer.getAttribute('aria-hidden') === 'true';
            drawer.setAttribute('aria-hidden', !isHidden);

        });
    });
});
